export const BuildingMaxLength = 45;
export const BuildingControlName = 'building';
export const BuildingLabel = 'Будинок';
export const BuildingPlaceholder = 'Будинок';
export const BuildingClasses = 'form-col w-20';
